const DATE_FORMAT = 'MM/DD/YYYY';
const TIME_FORMAT = 'hh:mm A';
const TIME_FORMAT_24 = 'HH:mm';
const DATE_TIME_FORMAT = 'MM/DD/YYYY, h:mm A';
const DATE_TIME_FORMAT_24 = 'MM/DD/YYYY, HH:mm';
const DAY_DATE_FORMAT = 'dddd, MM/DD/YYYY';
const MONTH_DATE_FORMAT = 'MMM DD, YYYY';
const MONTH_DATE_TIME_FORMAT = 'MMM DD, YYYY h:mm A';
const YEAR_DATE_FORMAT = 'YYYY-MM-DD';
const OTHER_DAY_DATE_FORMAT = 'ddd, MM/DD';
const YEAR_DATE_TIME_ETZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const DATETIME_FILE_FORMAT = 'YYYY-MM-DD--HHmmss';
export const TIME_ZONE_EST = 'America/New_York';
export const DATE_TIME_FORMAT_MOMENT = 'MM/DD/YYYY hh:mm:ss A';

const info = {
    DateFormat: DATE_FORMAT,
    TimeFormat: TIME_FORMAT,
    TimeFormat24: TIME_FORMAT_24,
    DateTimeFormat: DATE_TIME_FORMAT,
    DateTimeFormat24: DATE_TIME_FORMAT_24,
    DayWithDateFormat: DAY_DATE_FORMAT,
    MonthDateFormat: MONTH_DATE_FORMAT,
    MonthDateTimeFormat: MONTH_DATE_TIME_FORMAT,
    YearDateFormat: YEAR_DATE_FORMAT,
    DayWithoutYearFormat: OTHER_DAY_DATE_FORMAT,
    YearDateFormatWithETZ: YEAR_DATE_TIME_ETZONE_FORMAT,
    DateTimeFileFormat: DATETIME_FILE_FORMAT,
};

class CultureInfo {
    static GetCultureInfo() {
        return info;
    }
}

export default CultureInfo;
